import React, { memo } from "react";
import Countdown from "react-countdown";
import moment from "moment";
import StopwatchIcon from "@atlaskit/icon/glyph/stopwatch";
import Lozenge from "@atlaskit/lozenge";
import WarningIcon from "@atlaskit/icon/glyph/warning";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./JobStats.module.css";
import ShortcutIcon from "@atlaskit/icon/glyph/shortcut";
import useFetch from "../../../hooks/use-fetch";
const JobStats = ({ appType }) => {
  const url = `api/dashboard/widget/jobs/latest-status?jobType=${appType}`;
  const { data: jobStatDetails, isLoading, error } = useFetch(url);
  const { status = "", startTime = "" } = { ...jobStatDetails };
  const renderer = ({ hours, minutes, seconds }) => {
    return (
      <span>
        {hours} Hrs {minutes} Mins {seconds} secs
      </span>
    );
  };
  if (isLoading) {
    return (
      <div className={styles.headerCardContainer}>
        <div className={styles.headerCardTitle}>Job stats</div>
        <div className={styles.headerCardBody}>
          <div className={styles.headerCardField}>
            <Skeleton
              width={"150px"}
              count={1}
              baseColor="lightgrey"
              height={"10px"}
            />
          </div>
          <div className={styles.headerCardField}>
            <Skeleton
              width={"150px"}
              count={1}
              baseColor="lightgrey"
              height={"10px"}
            />
          </div>
        </div>
      </div>
    );
  }
  // let valForCountdown = 0;
  // if (new Date().getTimezoneOffset() * 60000 > 0) {
  //   valForCountdown = new Date().getTimezoneOffset() * 60000;
  // } else {
  //   valForCountdown = new Date().getTimezoneOffset() * 60000 * -1;
  // }
  let valForCountdown = 0;
  let start_Time = moment.utc();
  let endTime = moment.utc().add(1, "days");
  endTime.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  valForCountdown = endTime.diff(start_Time);
  return (
    <div className={styles.headerCardContainer}>
      <div className={styles.headerCardTitle}>Job stats</div>
      {jobStatDetails && !error ? (
        <div className={styles.headerCardBody}>
          {status === "NA" && appType === "Restore" ? (
            <div style={{ marginTop: "20px" }}>No Restores Found</div>
          ) : (
            <>
              <div className={styles.headerCardField}>
                <p className={styles.alignleft}>Status :&nbsp;</p>
                {status !== "" ? (
                  <div className={styles.alignleft}>
                    <Lozenge
                      appearance={
                        status.toLowerCase() === "scheduled" ||
                        status.toLowerCase() === "success"
                          ? "success"
                          : status.toLowerCase() === "error" ||
                            status.toLowerCase() === "paused"
                          ? "removed"
                          : "inprogress"
                      }
                      isBold
                      style={{ padding: "20px" }}
                    >
                      {status.toLowerCase() === "error"
                        ? "FAILED"
                        : status.toUpperCase()}
                    </Lozenge>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {status.toLowerCase() === "scheduled" && appType === "Backup" ? (
                <div
                  className={styles.headerCardField}
                  style={{ marginBottom: "0px" }}
                >
                  <p className={styles.alignleft}>Backup starts in : &nbsp;</p>
                  {
                    <div className={styles.alignleft}>
                      <span className={styles.countDown}>
                        <StopwatchIcon size="medium" />
                      </span>

                      <Countdown
                        renderer={renderer}
                        zeroPadTime={2}
                        date={start_Time + valForCountdown}
                      />
                    </div>
                  }
                </div>
              ) : (
                ""
              )}

              {appType === "Backup" && status.toLowerCase() === "paused" ? (
                <div className={styles.headerCardField}>
                  <div className={styles.alignleft}>
                    <Link to="/backup/settings">
                      Go to settings <ShortcutIcon size="small" />{" "}
                    </Link>
                  </div>
                  <div className={styles.alignleft}>
                    <Lozenge appearance="removed">
                      <WarningIcon size="small" /> Action Required
                    </Lozenge>
                  </div>
                </div>
              ) : (
                <div className={styles.headerCardField}>
                  <p className={styles.alignleft}>Start time (UTC) :&nbsp;</p>
                  {startTime !== "NA" || startTime !== "" ? (
                    <div className={styles.alignleft}>
                      <Lozenge
                        appearance="inprogress"
                        style={{ padding: "20px" }}
                      >
                        {moment.utc(startTime).format("llll")}
                      </Lozenge>
                    </div>
                  ) : (
                    "NA"
                  )}
                </div>
              )}
            </>
          )}
        </div>
      ) : (
        ""
        // <Skeleton height={10} width={"inherit"} count={2} baseColor="red" />
      )}
    </div>
  );
};

export default memo(JobStats);
